import DZOLogo_en from './assets/logo/logo_dzo_en.svg'
import DZOLogo_uk from './assets/logo/logo_dzo_uk.svg'
import ProzoroLogo from './assets/logo/logo_prozorro.svg'

export const LogoEn = DZOLogo_en
export const LogoUk = DZOLogo_uk
export const LogoProzoro = ProzoroLogo
